import Vue from 'vue';
import vClickOutside from 'v-click-outside';

Vue.directive('click-outside', vClickOutside.directive);
